/**
 * ESC layer stack.
 *
 * Every dismissible overlay registers while open and consumes ESC only when
 * it is top. Without this, ToolModal, WorkspaceOverlay and the voice picker
 * each bind window keydown independently and one ESC closes an arbitrary
 * subset.
 *
 * Module-level, deliberately: this is global keyboard arbitration, not
 * component state, and it must work across unrelated subtrees.
 *
 * ZERO IMPORTS — also unit-testable under node --test.
 */
const stack = [];

export function pushLayer(id) {
  const i = stack.indexOf(id);
  if (i !== -1) stack.splice(i, 1);
  stack.push(id);
}

export function popLayer(id) {
  const i = stack.indexOf(id);
  if (i !== -1) stack.splice(i, 1);
}

export function isTopLayer(id) {
  return stack.length > 0 && stack[stack.length - 1] === id;
}

export function __resetLayers() {
  stack.length = 0;
}
